<template>
  <v-container fluid grid-list-lg>
    <v-card>
      <v-app-bar flat>
        <v-icon>shop</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;ABM de Canales de Venta</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)">
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-app-bar>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12 sm6 md6 lg6>
            <v-card>
              <v-app-bar
                flat
                dense
                :color="$store.state.UiColors.crudToolbarList">
                <v-icon>list</v-icon>
                <v-toolbar-title class="font-weight-light"
                  >Lista</v-toolbar-title
                >
                <v-spacer></v-spacer>
              </v-app-bar>

              <v-flex left>
                <v-autocomplete
                  v-model="filtroEmpresaId"
                  :items="empresasFiltro"
                  item-text="nombre"
                  item-value="id"
                  label="Filtro por empresa"
                  placeholder="Sin Filtro"
                  :clearable="true"></v-autocomplete>
              </v-flex>

              <v-flex right>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Buscar por Nombre/Código"
                  single-line
                  hide-details></v-text-field>
              </v-flex>

              <v-data-table
                :headers="headers"
                :items="records"
                :server-items-length="totalItems"
                :loading="loading"
                :options.sync="options"
                v-model="selectedRow"
                :footer-props="{
                  itemsPerPageOptions: options.rowsPerPageItems,
                }">
                <template slot="no-data">
                  <v-alert :value="true" color="grey" icon="warning">
                    No se encontraron datos
                  </v-alert>
                </template>
                <template v-slot:item="{ item }">
                  <tr @click="viewItem(item)">
                    <!-- Le pongo la lista en la posicion del id, no se de qúe otra manera bindearlo. -->
                    <td class="text-xs-left">{{ item.empresaDescripcion }}</td>
                    <td class="text-xs-left">
                      {{ item.tipoCanalVentaDescripcion }}
                    </td>
                    <td class="text-xs-left">{{ item.nombre }}</td>

                    <td class="text-xs-left" v-if="item.inhabilitado">Baja</td>
                    <td class="text-xs-left" v-else></td>

                    <td class="text-xs-left">
                      <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                        v-show="canUpdate"
                        >edit</v-icon
                      >
                      <v-icon small @click="deleteItem(item)" v-show="canDelete"
                        >delete</v-icon
                      >
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md6 lg6>
            <v-card>
              <v-app-bar
                flat
                dense
                :color="$store.state.UiColors.crudToolbarDetail">
                <v-icon>location_city</v-icon>
                <v-toolbar-title class="font-weight-light"
                  >Detalle</v-toolbar-title
                >
                <v-spacer></v-spacer>

                <v-btn
                  v-if="!editMode"
                  :color="$store.state.UiColors.crudToolbarDetailButtons"
                  fab
                  small
                  top
                  @click="editItem()"
                  v-show="canCreate">
                  <v-icon medium>add_circle_outline</v-icon>
                </v-btn>

                <v-btn
                  v-if="model.id != null"
                  :color="$store.state.UiColors.crudToolbarDetailButtons"
                  fab
                  small
                  top
                  @click="editMode = !editMode"
                  v-show="canUpdate">
                  <v-icon v-if="editMode">cancel</v-icon>
                  <v-icon v-else>edit</v-icon>
                </v-btn>
              </v-app-bar>
              <v-card-text>
                <v-form :disabled="!editMode">
                  <v-layout>
                    <v-flex xs6>
                      <v-autocomplete
                        v-model="model.sucursalId"
                        :items="sucursales"
                        item-text="nombre"
                        item-value="id"
                        label="Sucursal Asociada"
                        placeholder="Seleccione una Sucursal"
                        :disabled="!editMode"
                        :menu-props="{ minWidth: '400' }">
                        <template v-slot:item="data">
                          <template v-if="typeof data.item !== 'object'">
                            <v-list-item-content
                              v-text="data.item"></v-list-item-content>
                          </template>
                          <template v-else>
                            <v-list-item-content>
                              <v-list-item-title
                                v-html="data.item.nombre"></v-list-item-title>
                              <v-list-item-subtitle
                                v-html="
                                  data.item.empresa
                                "></v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs6>                      
                      <v-autocomplete
                        v-model="model.tipoCanalVentaId"
                        :items="tiposCanalVenta"
                        item-text="descripcion"
                        item-value="id"
                        label="El canal de venta es un:"
                        placeholder="Seleccione uno"
                        :disabled="!editMode"
                        :menu-props="{ minWidth: '400' }">
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <p v-if="model.id === 0"></p>
                  <p v-else-if="!model.status.baja">Status: Activo</p>
                  <p v-else>Status: Inhabilitado</p>

                  <v-text-field
                    v-model="model.nombre"
                    label="Nombre"
                    required
                    :disabled="!editMode"
                    v-validate="'required'"
                    data-vv-name="nombre"
                    :error-messages="errors.collect('nombre')"></v-text-field>

                  <v-text-field
                    v-model="model.telefono"
                    label="Teléfono"
                    :disabled="!editMode"></v-text-field>

                  <app-domicilio-simple
                    propName="domicilio"
                    :value="model"
                    :editMode="editMode"></app-domicilio-simple>

                  <v-text-field
                    v-model="model.linkWhatsApp"
                    label="Link WhatsApp"
                    :disabled="!editMode"></v-text-field>

                  <v-card v-if="model.tipoCanalVentaId > 0">
                    <v-card-title>
                      <p
                        v-if="
                          model.tipoCanalVentaId === 1 ||
                          model.tipoCanalVentaId === 4
                        ">
                        Objetivos de la Sucursal
                      </p>
                      <p v-else-if="model.tipoCanalVentaId === 2">
                        Datos del Comercio
                      </p>
                      <p v-else-if="model.tipoCanalVentaId === 3">
                        Datos del Comercializador
                      </p>
                    </v-card-title>

                    <v-card-text
                      v-if="
                        model.tipoCanalVentaId === 1 ||
                        model.tipoCanalVentaId === 4
                      ">
                      <v-layout>
                        <v-flex xs6>
                          <v-text-field
                            v-model="model.objetivoVenta1"
                            label="Objetivo Venta 1"
                            :disabled="!editMode"
                            v-validate="
                              model.tipoCanalVentaId === 1 ||
                              model.tipoCanalVentaId === 4
                                ? 'required'
                                : ''
                            "
                            data-vv-name="objetivo venta 1"
                            :error-messages="
                              errors.collect('objetivo venta 1')
                            "></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="model.objetivoVenta2"
                            label="Objetivo Venta 2"
                            :disabled="!editMode"
                            v-validate="
                              model.tipoCanalVentaId === 1 ||
                              model.tipoCanalVentaId === 4
                                ? ''
                                : ''
                            "
                            data-vv-name="objetivo venta 2"
                            :error-messages="
                              errors.collect('objetivo venta 2')
                            "></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex xs6>
                          <v-text-field
                            v-model="model.objetivoCobranza1"
                            label="Objetivo Cobranza 1"
                            :disabled="!editMode"></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="model.objetivoCobranza2"
                            label="Objetivo Cobranza 2"
                            :disabled="!editMode"></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex xs6>
                          <v-text-field
                            v-model="model.contacto"
                            label="Encargado"
                            required
                            :disabled="!editMode"
                            v-validate="'required'"
                            data-vv-name="encargado"
                            :error-messages="
                              errors.collect('encargado')
                            "></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>

                    <v-card-text
                      v-if="
                        model.tipoCanalVentaId === 2 ||
                        model.tipoCanalVentaId === 3
                      ">
                      <v-layout>
                        <v-flex xs6>
                          <v-text-field
                            v-model="model.codigo"
                            label="Codigo"
                            :disabled="!editMode"
                            data-vv-name="codigo"
                            :error-messages="
                              errors.collect('codigo')
                            "></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-autocomplete
                            v-if="model.tipoCanalVentaId === 2"
                            v-model="model.grupoComercialId"
                            :items="gruposComerciales"
                            item-text="nombre"
                            item-value="id"
                            label="Grupo Comercial"
                            placeholder="Seleccione un Grupo Comercial"
                            :disabled="!editMode"
                            :menu-props="{ minWidth: '400' }"
                            v-validate="'required'"
                            data-vv-name="grupo comercial"
                            :error-messages="
                              errors.collect('grupo comercial')
                            "></v-autocomplete>
                        </v-flex>
                      </v-layout>

                      <v-layout>
                        <v-flex xs6>
                          <v-text-field
                            v-model="model.email"
                            label="Email"
                            :disabled="!editMode"
                            v-validate="'email'"
                            data-vv-name="email"
                            :error-messages="
                              errors.collect('email')
                            "></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="model.contacto"
                            label="Contacto"
                            :disabled="!editMode"></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout v-if="model.tipoCanalVentaId === 2">
                        <v-flex xs6>
                          <v-text-field
                            v-model="model.ejecutivo"
                            
                            label="Ejecutivo"
                            :disabled="!editMode"
                            data-vv-name="ejecutivo"
                            :error-messages="
                              errors.collect('ejecutivo')
                            "></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-autocomplete
                            v-model="model.regionComercioId"
                            :items="regionesComercio"
                            item-text="nombre"
                            item-value="id"
                            label="Región"
                            placeholder="Seleccione una Región"
                            :disabled="!editMode"
                            :menu-props="{ minWidth: '400' }"
                            v-validate="'required'"
                            data-vv-name="region"
                            :error-messages="
                              errors.collect('region')
                            "></v-autocomplete>
                        </v-flex>
                      </v-layout>

                      <v-layout v-if="model.tipoCanalVentaId === 2">
                        <v-flex xs6>
                          <v-autocomplete
                            v-model="model.rubroComercioId"
                            :items="rubrosComercio"
                            item-text="descripcion"
                            item-value="id"
                            label="Rubro"
                            placeholder="Seleccione un Rubro"
                            :disabled="!editMode"
                            :menu-props="{ minWidth: '400' }"
                            v-validate="'required'"
                            data-vv-name="rubroComercio"
                            :error-messages="
                              errors.collect('rubroComercio')
                            "></v-autocomplete>
                        </v-flex>
                      </v-layout>

                      <v-layout v-if="model.tipoCanalVentaId === 3">
                        <v-flex xs6>
                          <v-checkbox
                            v-model="model.linkCargaRapidaHabilitado"
                            label="Link Carga Rápida Habilitado"
                            :disabled="!editMode"></v-checkbox>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-if="model.linkCargaRapidaHabilitado"
                            v-model="model.usuarioCargaRapida"
                            label="Usuario Carga Rápida"
                            :disabled="!editMode"></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-if="model.linkCargaRapidaHabilitado"
                            v-model="model.passwordCargaRapida"
                            label="Contraseña Carga Rápida"
                            :disabled="!editMode"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>

                  <v-switch
                    v-model="model.restringirProductos"
                    label="Restringir Productos"
                    :editMode="editMode"></v-switch>

                  <v-container
                    v-if="model.restringirProductos"
                    :editMode="editMode">
                    <v-select
                      :items="listProductos"
                      v-model="model.productos"
                      item-text="descripcion"
                      item-value="id"
                      label="Tendra acceso sólo a los siguientes Productos"
                      multiple
                      :disabled="!editMode"></v-select>
                  </v-container>

                  <v-divider></v-divider>
                  <template v-if="$store.state.debugModeOn">
                    Debug Info:
                    <p></p>

                    Model: {{ model }}
                    <p></p>
                  </template>
                  <v-divider></v-divider>

                  <v-card-actions bottom>
                    <v-speed-dial direction="top" open-on-hover>
                      <template v-slot:activator>
                        <v-btn color="orange" text small v-show="editMode">
                          <v-icon color="orange">touch_app</v-icon>
                          Mas Acciones
                        </v-btn>
                      </template>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            small
                            text
                            color="green"
                            v-on="on"
                            @click="copiarDomicilio"
                            v-show="editMode">
                            Copiar Domicilio
                          </v-btn>
                        </template>
                        <span>Copia el domicilio de la sucursal elegida</span>
                      </v-tooltip>
                      <v-btn
                        small
                        text
                        color="green"
                        @click="updateStatus"
                        v-show="editMode">
                        <p v-if="model.status.baja">Habilitar</p>
                        <p v-else>Deshabilitar</p>
                      </v-btn>
                    </v-speed-dial>

                    <v-spacer></v-spacer>
                    <v-btn
                      color="success"
                      :disabled="!editMode"
                      @click="saveItem"
                      ><v-icon>save</v-icon>Guardar</v-btn
                    >
                  </v-card-actions>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { http } from "@/axios";
import Vue from "vue";
import { format } from "date-fns";

import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      suspend: false,
      search: "", // valor para búsqueda
      options: {
        // definición de paginación
        sortDesc: [false],
        sortBy: [""],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems: [5, 10, 20],
      },
      totalItems: 0, // va afuera de options
      headers: [
        // definición de columnas
        { text: "Empresa", value: "empresa", sortable: false },
        { text: "Tipo", value: "tipoCanalVenta" },
        { text: "Nombre", value: "nombre" },
        { text: "Status", value: "inhabilitado" },
        { text: "Acciones", value: "name", sortable: false },
      ],
      records: [], // registros
      selectedRow: [],
      sucursales: [],
      tiposCanalVenta: [],
      gruposComerciales: [],
      regionesComercio: [],
      rubrosComercio: [],
      empresasFiltro: [],
      filtroEmpresaId: 0,
      listProductos: [],
      model: { status: {} }, // registro para ver/editar
    };
  },
  async created() {
    this.loadSucursales();
    this.loadTiposCanalVenta();
    this.loadGruposComerciales();
    this.loadEmpresasFiltro();
    this.loadProductos();
    this.loadRegionesComercio();
    this.loadRubrosComercio();
  },
  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
    search() {
      this.getItems();
    },
    filtroEmpresaId() {
      if (this.filtroEmpresaId == undefined) this.filtroEmpresaId = 0;
      this.getItems();
    },
    "model.grupoComercialId"() {
      if (this.model.codigo != "") return;

      let i = 0;
      for (i = 0; i < this.gruposComerciales.length; i++) {
        if (this.gruposComerciales[i].id == this.model.grupoComercialId) {
          this.model.codigo = this.gruposComerciales[i].codigo;
          break;
        }
      }
    },
    "model.tipoCanalVentaId"() {
      this.resetTipoCanalVenta();
    },
  },
  computed: {
    ...mapGetters([
      "checkCanCreate",
      "checkCanUpdate",
      "checkCanDelete",
      "getActionFromLink",
    ]),
    canCreate: function () {
      return this.checkCanCreate(this.$route.path);
    },
    canUpdate: function () {
      return this.checkCanUpdate(this.$route.path);
    },
    canDelete: function () {
      return this.checkCanDelete(this.$route.path);
    },
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
  },
  methods: {
    ...mapMutations([
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),
    async getItems() {
      this.loading = true;
      this.$validator.reset();

      try {
        var result = await http.get(
          "canalesVenta?nombre=" +
            this.search +
            "&empresaId=" +
            this.filtroEmpresaId +
            "&limit=" +
            this.options.itemsPerPage +
            "&page=" +
            this.options.page +
            "&sortby=" +
            this.options.sortBy +
            "&descending=" +
            (this.options.sortDesc.length > 0 ? this.options.sortDesc : "false")
        );

        this.records = result.list;
        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async resetState() {
      this.$validator.reset();
      this.editMode = false;
    },
    async getItem(id) {
      this.loading = true;
      this.resetState();

      try {
        var result = await http.get("canalesVenta/" + id);

        this.model = result;
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.loading = false;
    },
    async viewItem(item) {
      if (this.suspend) return;

      this.selectedRow.pop();
      this.selectedRow.push(item);

      await this.getItem(item.id);
      this.editMode = false;
    },
    async clearAndReload() {
      // Clear the data inside of the form
      this.model = { status: {} };
      this.resetState();

      // Refresco la grilla
      await this.getItems();
    },
    async editItem(item) {
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)

      if (!item) await this.getItem(0);
      else await this.getItem(item.id);

      this.editMode = true;
      this.suspend = false;
    },
    async cancelEdit() {
      this.editMode = false;
    },
    async saveItem() {
      const isUpdate = !(this.model.id === 0);

      await this.$validator.validateAll();

      if (this.errors.items.length > 0) {
        this.alertError(this.errors.items[0].msg);
        return;
      }

      if (isUpdate) {
        try {
          await http.put(
            "canalesVenta",
            JSON.stringify({ canalVenta: this.model })
          );
          this.alertSuccess("Los cambios han sido guardados.");
          this.clearAndReload();
        } catch (error) {
          Vue.$log.error(error);
          // Error
          this.alertError(error);
        }
      } else {
        try {
          await http.post(
            "canalesVenta",
            JSON.stringify({ canalVenta: this.model })
          );
          this.alertSuccess("Los cambios han sido guardados.");
          this.clearAndReload();
        } catch (error) {
          // Error
          Vue.$log.error(error);
          this.alertError(error);
        }
      }
    },
    async deleteItem(item) {
      if (
        confirm(
          "¿Confirma la eliminación del canal de venta " + item.nombre + "?"
        )
      ) {
        try {
          await http.delete("canalesVenta?id=" + item.id);
          this.alertSuccess("El canal de venta ha sido eliminado.");
          this.clearAndReload();
        } catch (error) {
          // Error
          Vue.$log.error(error);
          this.alertError(error);
        }
      }
    },
    async copiarDomicilio() {
      if (this.model.sucursalId) {
        try {
          var result = await http.get("sucursales/" + this.model.sucursalId);

          this.model.domicilio = result.domicilio;
        } catch (error) {
          // Error
          this.alertError(error);
        }
      } else {
        this.alertWarning(
          "Por favor, seleccione una empresa de la lista y vuelva a intentar."
        );
      }
    },
    async updateStatus() {
      this.loading = true;
      this.model.status.baja = !this.model.status.baja;
      try {
        await http.put(
          "canalesVenta/updatestatus",
          JSON.stringify({
            status: { entidadId: this.model.id, status: this.model.status },
          })
        );
        this.alertSuccess("Los cambios han sido guardados.");
        this.clearAndReload();
      } catch (error) {
        Vue.$log.error(error);
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSucursales() {
      this.loading = true;
      try {
        var result = await http.get("sucursales"); // traigo todas
        this.sucursales = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async loadTiposCanalVenta() {
      this.loading = true;
      try {
        var result = await http.get("tiposcanalventa");
        this.tiposCanalVenta = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async loadGruposComerciales() {
      this.loading = true;
      try {
        var result = await http.get("gruposComerciales?limit=999"); // traigo todas
        this.gruposComerciales = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async loadEmpresasFiltro() {
      this.loading = true;
      try {
        var result = await http.get("empresas"); // traigo todas
        this.empresasFiltro = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async loadProductos() {
      this.listProductos = [];
      this.loading = true;
      try {
        var result = await http.get("productos");

        this.listProductos = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadRegionesComercio() {
      this.loading = true;
      try {
        var result = await http.get("regionescomercio"); // traigo todas
        this.regionesComercio = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async loadRubrosComercio() {
      this.loading = true;
      try {
        var result = await http.get("tiposrubrocomercio");
        this.rubrosComercio = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    resetTipoCanalVenta() {
      this.$validator.reset;
      /* let items = this.$validator.fields.items;
      for(let i = 0; i<this.$validator.fields.items.length ; i++)
      {
        Vue.$log.debug(items[i].name);
      }
      Vue.$log.debug(this.$validator); */

      if (
        this.model.tipoCanalVentaId === 1 ||
        this.model.tipoCanalVentaId === 4
      ) {
        this.model.codigo = "";
        this.model.grupoComercialId = 0;
        this.model.email = "";
      } else {
        
        this.model.objetivoVenta1 = "";        
        this.model.objetivoVenta2 = "";        
        this.model.objetivoCobranza1 = "";        
        this.model.objetivoCobranza2 = "";
        
        if (this.model.tipoCanalVentaId === 3) {
          this.model.grupoComercialId = 0;
        }
      }
    },
  },
};
</script>
